import type { ReactNode } from 'react';

export const symbol_drive_file_rename: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M434-260h256q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H494l-60 60Zm-164 0h81q5.57 0 10.78-2 5.22-2 10.22-7l289-290q9-9 13.5-20.5T679-602q0-11-4-22t-13-20l-37-37q-9-9-20-13.5t-23-4.5q-11 0-22 4t-20 13L249-392q-5 5-7 10.22-2 5.21-2 10.78v81q0 12.75 8.63 21.37Q257.25-260 270-260Zm349-342-37-37 37 37ZM300-320v-38l201-200 19 18 18 19-200 201h-38Zm220-220 18 19-37-37 19 18ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
